import React from 'react';
import { Form } from 'react-bootstrap';
import * as styles from './Diy.module.css';

const Personalization = ({ formData, handleInputChange }) => {
  console.log('fromData', formData);
  return (
    <>
      <Form.Group className={styles.persona} controlId="name" key="name">
        <Form.Label className={styles.diyLabel}>Personalization</Form.Label>
        <Form.Control
          name="name"
          type="text"
          className={styles?.name}
          placeholder="Enter Name"
          value={formData?.name}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
      <Form.Group
        className={styles.persona}
        controlId="policyNo"
        key="policyNo"
      >
        <Form.Control
          name="policyNo"
          type="text"
          className={styles?.policyNo}
          placeholder="Enter Policy No"
          value={formData?.policyNo}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </Form.Group>
    </>
  );
};

export default Personalization;
